// ---------------------------------------------
// auto-generated from materia/flash.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MSourceRail, MChart, MRail, MTopBar } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";

// ──────────────────────────────────────────────────────────
// Reel chrome: mobile reel inside desktop, with context columns
// ──────────────────────────────────────────────────────────
export const ReelFrame = ({ children, act = 3, total = 5, time = "00:14" }) => (
  <div className="reel-frame">
    {/* top safe area */}
    <div style={{ height: 28 }}/>
    <div style={{ padding: "0 16px", display: "flex", justifyContent: "center" }}>
      <div className="m-dots">
        {Array.from({ length: total }).map((_, i) => (
          <i key={i} className={i < act - 1 ? "done" : i === act - 1 ? "on" : ""}/>
        ))}
      </div>
    </div>
    <div style={{ padding: "10px 16px 0", display: "flex", gap: 6, alignItems: "center" }}>
      <MChip>FLASH · 20s</MChip>
      <MChip variant="neutral">iniciación</MChip>
      <span style={{ flex: 1 }}/>
      <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>{time}</span>
    </div>
    <div style={{ padding: "12px 16px", flex: 1, overflow: "hidden", position: "relative", height: "calc(800px - 86px - 60px)" }}>
      {children}
    </div>
    {/* footer with rail */}
    <div style={{
      position: "absolute", bottom: 0, left: 0, right: 0, height: 60,
      borderTop: "1px solid var(--m-line)", background: "var(--m-bg-deep)",
      padding: "0 14px", display: "flex", alignItems: "center", justifyContent: "space-between",
    }}>
      <div style={{ display: "flex", gap: 8 }}>
        <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="cc" size={12}/></button>
        <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="freeze" size={12}/></button>
      </div>
      <button className="m-iconbtn primary" style={{ width: 40, height: 40, borderRadius: 99, background: "rgba(201,122,75,0.18)" }}>
        <Icon name="pause" size={16}/>
      </button>
      <div style={{ display: "flex", gap: 8 }}>
        <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="book" size={12}/></button>
        <button className="m-iconbtn" style={{ width: 28, height: 28 }}><Icon name="headset" size={12}/></button>
      </div>
    </div>
  </div>
);

export const FlashDesktopShell = ({ label, leftPanel, rightPanel, reel, footer = true }) => (
  <div className="m-screen-d materia" data-screen-label={label}>
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="explore"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <MTopBar crumbs={["EducaFinaz", "Educa", "Flash", "TREND_STRUCTURE_20S"]}/>
        <div style={{ flex: 1, display: "grid", gridTemplateColumns: "minmax(280px, 1fr) auto minmax(280px, 1fr)", gap: 24, padding: "24px 32px", alignItems: "start", minHeight: 0, overflow: "hidden" }}>
          <div>{leftPanel}</div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-start" }}>
            {reel}
          </div>
          <div>{rightPanel}</div>
        </div>
        {footer && <MSourceRail source="vendor_primary · XYZ 1D" time="14:32 UTC" note="FLASH · 20s · TREND_STRUCTURE_20S · iniciación"/>}
      </div>
    </div>
  </div>
);

// Side panels (reused) ─────────────────────────────────────
export const FlashContextLeft = () => (
  <div className="m-panel" style={{ padding: 16 }}>
    <MEye>Contexto editorial</MEye>
    <div className="m-serif" style={{ fontSize: 17, lineHeight: 1.3, marginTop: 10, color: "var(--m-text)" }}>
      Una tendencia no es una línea recta.
    </div>
    <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 8, lineHeight: 1.4, textWrap: "pretty" }}>
      Un Flash dura 20 s. Una sola idea, una microacción, un error frecuente desmontado.
    </div>
    <div style={{ marginTop: 14 }}>
      <MEye>Estructura · 5 actos</MEye>
      <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
        {[
          { a: "A1", t: "Hook · gráfico sorpresa" },
          { a: "A2", t: "Concepto · definición visual" },
          { a: "A3", t: "Evidencia · overlays en chart", now: true },
          { a: "A4", t: "Cautela · misconception" },
          { a: "A5", t: "Microacción" },
        ].map((b, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 11.5,
            color: b.now ? "var(--m-text)" : "var(--m-text-2)" }}>
            <span className="mono" style={{ width: 22, color: b.now ? "var(--m-primary)" : "var(--m-text-3)", fontSize: 10 }}>{b.a}</span>
            <span style={{ flex: 1 }}>{b.t}</span>
            {b.now && <span style={{ width: 6, height: 6, borderRadius: 99, background: "var(--m-primary)" }}/>}
          </div>
        ))}
      </div>
    </div>

    <div className="m-divider" style={{ margin: "16px 0" }}/>
    <MEye>Objetivo de aprendizaje</MEye>
    <div style={{ fontSize: 12.5, marginTop: 8, lineHeight: 1.35, textWrap: "pretty" }}>
      Identificar una tendencia por <span style={{ color: "var(--m-accent)" }}>estructura</span>, no por una vela.
    </div>

    <div className="m-divider" style={{ margin: "16px 0" }}/>
    <MEye>Misconception declarada</MEye>
    <div style={{ marginTop: 8 }}>
      <div className="m-misconception" style={{ padding: "10px 12px" }}>
        <div className="lbl">vela_aislada_define_tendencia</div>
        <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 4, lineHeight: 1.35 }}>
          Una vela roja no rompe una secuencia de mínimos crecientes.
        </div>
      </div>
    </div>
  </div>
);

export const FlashContextRight = ({ feedback = null, micro = false, end = false }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
    {/* Source */}
    <div className="m-panel" style={{ padding: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <MEye>Fuente</MEye>
        <MChip variant="live">live · delay 15m</MChip>
      </div>
      <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 4, fontFamily: "var(--m-t-mono)", fontSize: 10.5, color: "var(--m-text-2)" }}>
        <div><span style={{ color: "var(--m-text-3)" }}>publisher</span>  vendor_primary</div>
        <div><span style={{ color: "var(--m-text-3)" }}>dataset</span>    DB.market_ohlcv</div>
        <div><span style={{ color: "var(--m-text-3)" }}>símbolo</span>    XYZ · 1D</div>
        <div><span style={{ color: "var(--m-text-3)" }}>retrieved</span>  14:32 UTC · 2026-05-17</div>
        <div><span style={{ color: "var(--m-text-3)" }}>license</span>    tier_2 · uso educativo</div>
      </div>
      <div className="m-divider" style={{ margin: "12px 0" }}/>
      <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>CLAIM STRENGTH</div>
      <div style={{ marginTop: 6, display: "grid", gridTemplateColumns: "1fr auto", rowGap: 4, fontSize: 11, columnGap: 12 }}>
        <span style={{ color: "var(--m-text-2)" }}>observación</span><span className="mono" style={{ color: "var(--m-positive)" }}>HIGH</span>
        <span style={{ color: "var(--m-text-2)" }}>interpretación</span><span className="mono" style={{ color: "var(--m-warn)" }}>MEDIUM</span>
        <span style={{ color: "var(--m-text-2)" }}>causalidad</span><span className="mono" style={{ color: "var(--m-text-3)" }}>NOT CLAIMED</span>
      </div>
    </div>

    {/* Related / next */}
    {!feedback && !end && (
      <div className="m-panel" style={{ padding: 16 }}>
        <MEye>Si quieres profundizar</MEye>
        <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
          {[
            { i: "movie", t: "Soportes, resistencias y rupturas", d: "EXPLICA · 7 min" },
            { i: "ind",   t: "Multi-timeframe · alineación", d: "EXPLICA · 6 min" },
            { i: "spark", t: "RSI alto no significa vender",   d: "FLASH · 20 s" },
          ].map((r, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 10, padding: 8, borderRadius: 4,
              border: "1px solid var(--m-line)", background: "var(--m-metal-2)",
            }}>
              <Icon name={r.i} size={14} style={{ color: "var(--m-primary)" }}/>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 500 }}>{r.t}</div>
                <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", marginTop: 2 }}>{r.d}</div>
              </div>
              <Icon name="next" size={13} style={{ color: "var(--m-text-3)" }}/>
            </div>
          ))}
        </div>
      </div>
    )}

    {/* Tutor floating */}
    <div className="m-panel" style={{ padding: 14, border: "1px solid rgba(216,168,104,0.3)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: 99, background: "rgba(216,168,104,0.16)", display: "grid", placeItems: "center" }}>
          <Icon name="help" size={14} style={{ color: "var(--m-accent)" }}/>
        </div>
        <div style={{ flex: 1 }}>
          <MEye>Tutor MCP</MEye>
          <div style={{ fontSize: 11, color: "var(--m-text-2)", marginTop: 2 }}>profesor_analista · socrático</div>
        </div>
        <Icon name="shield" size={14} style={{ color: "var(--m-text-3)" }}/>
      </div>
      <div style={{
        marginTop: 10, padding: 10, fontSize: 12, lineHeight: 1.4,
        background: "var(--m-bg-deep)", borderRadius: 4, color: "var(--m-text)", textWrap: "pretty"
      }}>
        “Antes de mirar la vela roja, ¿qué dicen los <span style={{ color: "var(--m-accent)" }}>mínimos previos</span>?”
      </div>
      <div style={{ marginTop: 8, display: "flex", gap: 6 }}>
        <button className="m-btn sm ghost"><Icon name="lightbulb" size={11}/> Pista 1/3</button>
        <button className="m-btn sm ghost"><Icon name="book" size={11}/> Glosario</button>
      </div>
    </div>
  </div>
);

// ──────────────────────────────────────────────────────────
// 01 · Player · A3 evidence
// ──────────────────────────────────────────────────────────
export const ScreenMFlashPlayer = () => (
  <FlashDesktopShell
    label="Flash · Player · A3"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight/>}
    reel={
      <ReelFrame act={3} time="00:11 / 00:20">
        <MEye>A3 · Evidencia</MEye>
        <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.18, letterSpacing: "-0.02em", marginTop: 8, textWrap: "balance" }}>
          Una tendencia deja <span style={{ color: "var(--m-accent)" }}>máximos y mínimos</span> cada vez más altos.
        </div>
        <div style={{ marginTop: 18, position: "relative" }}>
          <MChart width={328} height={300} caption="XYZ · 1D · 28 sesiones" ohlcLabel={false}
            yLabels={["110","106","102","98","94"]} xLabels={["abr","may","jun","jul","ago"]}
            overlays={[
              { type: "swing", xPct: 18, yPct: 78, label: "HL" },
              { type: "swing", xPct: 40, yPct: 62, label: "HL" },
              { type: "swing", xPct: 64, yPct: 40, label: "HH" },
              { type: "swing", xPct: 82, yPct: 28, label: "HH" },
              { type: "trend", from: [12, 86], to: [88, 36], color: "rgba(216,168,104,0.6)" },
            ]}/>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 02 · Microaction · tap-select
// ──────────────────────────────────────────────────────────
export const ScreenMFlashMicro = () => (
  <FlashDesktopShell
    label="Flash · Microaction"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight micro/>}
    reel={
      <ReelFrame act={5} time="00:17 · congelado">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <MChip variant="warn">microacción</MChip>
        </div>
        <div style={{ fontSize: 19, fontWeight: 600, lineHeight: 1.2, letterSpacing: "-0.01em", marginTop: 10, textWrap: "balance" }}>
          Toca el <span style={{ color: "var(--m-accent)" }}>mínimo creciente</span> que mantiene la tendencia.
        </div>
        <div style={{ marginTop: 14, position: "relative" }}>
          <MChart width={328} height={310} caption="" ohlcLabel={false}
            yLabels={[]} xLabels={[]}
            overlays={[
              { type: "trend", from: [12, 86], to: [88, 36], color: "rgba(216,168,104,0.4)", dashed: true },
            ]}/>
          {/* Tap targets — 44×44 visible glow on one */}
          {[
            { x: 22, y: 78, l: "1", glow: false },
            { x: 42, y: 60, l: "2", glow: true },
            { x: 62, y: 42, l: "3", glow: false },
            { x: 82, y: 30, l: "4", glow: false },
          ].map((s, i) => (
            <div key={i} style={{
              position: "absolute",
              left: `calc(${s.x}% - 22px)`, top: `calc(${s.y}% - 22px)`,
              width: 44, height: 44, borderRadius: 99,
              border: `1.5px solid ${s.glow ? "var(--m-accent)" : "rgba(216,168,104,0.4)"}`,
              background: s.glow ? "rgba(216,168,104,0.18)" : "rgba(216,168,104,0.06)",
              display: "grid", placeItems: "center",
              boxShadow: s.glow ? "0 0 24px rgba(216,168,104,0.45)" : "none",
            }}>
              <span className="mono" style={{ fontSize: 11, color: s.glow ? "var(--m-accent)" : "var(--m-text-2)" }}>{s.l}</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", gap: 6 }}>
            <button className="m-btn ghost sm"><Icon name="lightbulb" size={11}/> Pista 1/3</button>
            <button className="m-btn ghost sm"><Icon name="retry" size={11}/></button>
          </div>
          <span style={{ display: "flex", gap: 4 }}>
            <span className="m-kbd">1</span><span className="m-kbd">2</span><span className="m-kbd">3</span><span className="m-kbd">4</span>
          </span>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 03 · FeedbackCorrect
// ──────────────────────────────────────────────────────────
export const ScreenMFlashCorrect = () => (
  <FlashDesktopShell
    label="Flash · FeedbackCorrect"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight feedback="correct"/>}
    reel={
      <ReelFrame act={5} time="00:19">
        <div className="m-feedback-correct" style={{ padding: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 26, height: 26, borderRadius: 99, background: "var(--m-positive)", color: "#0f1a06", display: "grid", placeItems: "center" }}>
              <Icon name="check" size={14}/>
            </div>
            <div className="mono" style={{ fontSize: 10.5, letterSpacing: "0.14em", color: "var(--m-positive)", textTransform: "uppercase" }}>Correcto</div>
          </div>
          <div style={{ fontSize: 17, fontWeight: 600, marginTop: 10, lineHeight: 1.25, textWrap: "balance" }}>
            Has mirado <span style={{ color: "var(--m-positive)" }}>estructura</span>, no color de vela.
          </div>
          <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
            La tendencia se sostiene en mínimos crecientes, no en una vela aislada.
          </div>
        </div>
        <div style={{ marginTop: 14 }}>
          <MChart width={328} height={180} caption="HL identificado" ohlcLabel={false} showVolume={false}
            yLabels={[]} xLabels={[]}
            overlays={[
              { type: "swing", xPct: 42, yPct: 56, label: "HL" },
              { type: "trend", from: [10, 86], to: [88, 34], color: "rgba(155,184,106,0.6)" },
            ]}/>
        </div>
        <div style={{ marginTop: 14 }}>
          <MEye>Próximo paso</MEye>
          <div className="m-panel" style={{ marginTop: 8, padding: 12, display: "flex", alignItems: "center", gap: 10 }}>
            <Icon name="movie" size={14} style={{ color: "var(--m-primary)" }}/>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>Multi-timeframe</div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)" }}>EXPLICA · 6 min</div>
            </div>
            <Icon name="next" size={14} style={{ color: "var(--m-primary)" }}/>
          </div>
          <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
            <button className="m-btn ghost sm" style={{ flex: 1 }}><Icon name="save" size={11}/> Repaso</button>
            <button className="m-btn ghost sm" style={{ flex: 1 }}><Icon name="share" size={11}/> Compartir</button>
          </div>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 04 · FeedbackIncorrect
// ──────────────────────────────────────────────────────────
export const ScreenMFlashIncorrect = () => (
  <FlashDesktopShell
    label="Flash · FeedbackIncorrect"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight feedback="incorrect"/>}
    reel={
      <ReelFrame act={5} time="00:19">
        <div className="m-feedback-incorrect" style={{ padding: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 26, height: 26, borderRadius: 99, background: "rgba(201,92,78,0.16)", color: "var(--m-negative)", display: "grid", placeItems: "center" }}>
              <Icon name="retry" size={13}/>
            </div>
            <div className="mono" style={{ fontSize: 10.5, letterSpacing: "0.14em", color: "var(--m-negative)", textTransform: "uppercase" }}>Casi</div>
          </div>
          <div style={{ fontSize: 17, fontWeight: 600, marginTop: 10, lineHeight: 1.25, textWrap: "balance" }}>
            Tendencia es <span style={{ color: "var(--m-text)" }}>secuencia</span>, no una sola vela.
          </div>
          <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
            Marcaste un máximo, no un mínimo creciente.
          </div>
        </div>
        <div style={{ marginTop: 14 }}>
          <MChart width={328} height={170} caption="HL correctos" ohlcLabel={false} showVolume={false}
            yLabels={[]} xLabels={[]}
            overlays={[
              { type: "swing", xPct: 18, yPct: 78, label: "HL" },
              { type: "swing", xPct: 42, yPct: 60, label: "HL" },
              { type: "swing", xPct: 66, yPct: 42, label: "HL" },
            ]}/>
        </div>
        <div style={{ marginTop: 12 }}>
          <div className="m-misconception" style={{ padding: 12 }}>
            <div className="lbl">misconception detectada</div>
            <div style={{ fontSize: 12, fontWeight: 600, marginTop: 4 }}>vela_aislada_define_tendencia</div>
            <div style={{ fontSize: 11, color: "var(--m-text-2)", marginTop: 4 }}>Remediación: Flash · La ruptura que falla también enseña</div>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 70, left: 14, right: 14, display: "flex", gap: 6 }}>
          <button className="m-btn ghost sm" style={{ flex: 1 }}><Icon name="lightbulb" size={11}/> Pista 1</button>
          <button className="m-btn ghost sm" style={{ flex: 1 }}><Icon name="book" size={11}/> Explica</button>
          <button className="m-btn primary sm" style={{ flex: 1.3 }}><Icon name="retry" size={11}/> Reintentar</button>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 05 · EndCard
// ──────────────────────────────────────────────────────────
export const ScreenMFlashEnd = () => (
  <FlashDesktopShell
    label="Flash · EndCard"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight end/>}
    reel={
      <ReelFrame act={5} time="00:20">
        <MEye>Has aprendido</MEye>
        <div className="m-serif" style={{ fontSize: 21, lineHeight: 1.2, marginTop: 8, textWrap: "balance" }}>
          Una tendencia se reconoce por <span style={{ color: "var(--m-accent)", fontStyle: "normal" }}>estructura</span>, no por una vela.
        </div>
        <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
          {[
            { lbl: "CONCEPTO", c: "var(--m-primary)", t: "Secuencia de HH y HL." },
            { lbl: "EVIDENCIA", c: "var(--m-positive)", t: "Tres mínimos consecutivos." },
            { lbl: "CAUTELA", c: "var(--m-warn)", t: "Una vela roja no invalida la secuencia." },
          ].map((c, i) => (
            <div key={i} style={{
              padding: 10, borderLeft: `2px solid ${c.c}`,
              background: "rgba(0,0,0,0.25)", borderRadius: "0 4px 4px 0",
            }}>
              <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.14em", color: c.c }}>{c.lbl}</div>
              <div style={{ fontSize: 12, marginTop: 3 }}>{c.t}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14 }}>
          <MEye>Próximo nodo</MEye>
          <div className="m-panel" style={{ marginTop: 8, padding: 12, border: "1px solid rgba(201,122,75,0.35)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <MChip variant="copper">EXPLICA · 7 min</MChip>
              <Icon name="next" size={14} style={{ color: "var(--m-primary)" }}/>
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, marginTop: 8 }}>Soportes, resistencias y rupturas</div>
            <div style={{ fontSize: 11, color: "var(--m-text-2)", marginTop: 3 }}>4 ejercicios · 1 transferencia</div>
          </div>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 06 · Flash · True/False (RSI myth)
// ──────────────────────────────────────────────────────────
export const ScreenMFlashTF = () => (
  <FlashDesktopShell
    label="Flash · V/F · RSI myth"
    leftPanel={
      <div className="m-panel" style={{ padding: 16 }}>
        <MEye>Contexto editorial</MEye>
        <div className="m-serif" style={{ fontSize: 17, lineHeight: 1.3, marginTop: 10 }}>
          RSI alto no significa vender.
        </div>
        <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 8, lineHeight: 1.4 }}>
          El RSI mide momentum, no decisiones. Un valor &gt;70 indica fuerza, no agotamiento garantizado.
        </div>
        <div className="m-divider" style={{ margin: "14px 0" }}/>
        <MEye>Objetivo</MEye>
        <div style={{ fontSize: 12.5, marginTop: 8, lineHeight: 1.35 }}>
          Separar el indicador de la decisión.
        </div>
        <div className="m-divider" style={{ margin: "14px 0" }}/>
        <MEye>Misconception declarada</MEye>
        <div className="m-misconception" style={{ marginTop: 8, padding: 10 }}>
          <div className="lbl">rsi_overbought_means_sell</div>
          <div style={{ fontSize: 11.5, marginTop: 4, color: "var(--m-text-2)", lineHeight: 1.35 }}>
            “Sobrecompra” es un término técnico, no una orden.
          </div>
        </div>
      </div>
    }
    rightPanel={<FlashContextRight/>}
    reel={
      <ReelFrame act={5} time="00:14">
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <MChip variant="warn">V / F</MChip>
          <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>microacción</span>
        </div>
        <div className="m-serif" style={{ fontSize: 20, lineHeight: 1.25, marginTop: 10, textWrap: "balance" }}>
          “RSI alto siempre anticipa una caída.”
        </div>
        <div style={{ marginTop: 12 }}>
          <MChart width={328} height={150} caption="RSI 14 · XYZ" ohlcLabel={false} showVolume={false}
            yLabels={["80","70","50","30","20"]} xLabels={[]}
            overlays={[
              { type: "zone", topPct: 6, bottomPct: 26, color: "copper", label: "sobrecompra" },
              { type: "hline", yPct: 18, color: "rgba(216,168,104,0.5)", dashed: true, label: "70" },
              { type: "curve", d: "M 8 110 Q 50 30, 100 50 T 200 35 T 300 70", color: "rgba(201,122,75,0.7)", strokeWidth: 1.5 },
            ]}/>
        </div>
        <div style={{ marginTop: 16, display: "flex", gap: 10 }}>
          <button className="m-option" style={{ flex: 1, justifyContent: "center", padding: "18px 12px" }}>
            <div className="radio"/>
            <span style={{ fontSize: 14, fontWeight: 600, letterSpacing: "0.04em" }}>VERDADERO</span>
            <span className="m-kbd" style={{ marginLeft: "auto" }}>1</span>
          </button>
          <button className="m-option selected" style={{ flex: 1, justifyContent: "center", padding: "18px 12px",
            borderColor: "var(--m-accent)" }}>
            <div className="radio"/>
            <span style={{ fontSize: 14, fontWeight: 600, letterSpacing: "0.04em" }}>FALSO</span>
            <span className="m-kbd" style={{ marginLeft: "auto" }}>2</span>
          </button>
        </div>
        <div style={{ position: "absolute", bottom: 76, left: 14, right: 14, display: "flex", justifyContent: "space-between" }}>
          <button className="m-btn ghost sm"><Icon name="lightbulb" size={11}/> Pista 1/3</button>
          <button className="m-btn accent sm"><Icon name="check" size={11}/> Enviar</button>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 07 · Flash · FreezePanel
// ──────────────────────────────────────────────────────────
export const ScreenMFlashFreeze = () => (
  <FlashDesktopShell
    label="Flash · FreezePanel"
    leftPanel={<FlashContextLeft/>}
    rightPanel={<FlashContextRight/>}
    reel={
      <ReelFrame act={3} time="00:14 · congelado">
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <MChip variant="warn"><Icon name="freeze" size={10}/> congelado</MChip>
          <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>valores fijos con timestamp</span>
        </div>
        {/* frozen chart with ring */}
        <div style={{
          marginTop: 12, padding: 1, borderRadius: 10,
          background: "linear-gradient(135deg, rgba(216,168,104,0.6), rgba(201,122,75,0.5))",
        }}>
          <MChart width={326} height={170} caption="XYZ · 1D · 14:32 UTC" ohlcLabel={false} showVolume={false}
            yLabels={[]} xLabels={[]}
            overlays={[
              { type: "swing", xPct: 18, yPct: 78, label: "HL" },
              { type: "swing", xPct: 40, yPct: 60, label: "HL" },
              { type: "swing", xPct: 64, yPct: 40, label: "HH" },
            ]}/>
        </div>
        <div style={{ marginTop: 12 }}>
          <MEye>Acciones contextuales</MEye>
          <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
            {[
              { i: "draw", t: "Dibujar zona" },
              { i: "tag",  t: "Etiquetar swings" },
              { i: "link", t: "Abrir fuente" },
              { i: "help", t: "Preguntar tutor" },
              { i: "book", t: "Glosario · HL" },
              { i: "movie",t: "Explica relacionado" },
            ].map((a, i) => (
              <button key={i} className="m-panel" style={{
                padding: "8px 10px", display: "flex", alignItems: "center", gap: 8,
                fontSize: 11.5, color: "var(--m-text)", borderRadius: 4, cursor: "pointer",
                background: "var(--m-metal-2)",
              }}>
                <Icon name={a.i} size={12} style={{ color: "var(--m-primary)" }}/>
                {a.t}
              </button>
            ))}
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 70, left: 14, right: 14 }}>
          <button className="m-btn primary" style={{ width: "100%" }}>
            <Icon name="play" size={12}/> Reanudar desde 00:14
          </button>
        </div>
      </ReelFrame>
    }
  />
);

// ──────────────────────────────────────────────────────────
// 08 · Flash · ReadingCard (desktop article view)
// ──────────────────────────────────────────────────────────
export const ScreenMFlashReading = () => (
  <div className="m-screen-d materia" data-screen-label="Flash · Reading">
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="explore"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <MTopBar crumbs={["EducaFinaz", "Educa", "Flash", "TREND_STRUCTURE_20S", "Reading"]}/>
        <div style={{ flex: 1, display: "grid", gridTemplateColumns: "240px minmax(0, 1fr) 280px", gap: 24, padding: "30px 40px", overflow: "hidden" }}>
          {/* TOC */}
          <div>
            <MEye>Reading mode</MEye>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6, fontSize: 12, color: "var(--m-text-2)" }}>
              <a className="mono" style={{ color: "var(--m-primary)" }}>· Objetivo</a>
              <a className="mono">· Definición visual</a>
              <a className="mono">· Evidencia · HH y HL</a>
              <a className="mono">· Cautela · vela aislada</a>
              <a className="mono">· Microejercicio</a>
              <a className="mono">· Fuente y versión</a>
            </div>
            <div className="m-divider" style={{ margin: "16px 0" }}/>
            <button className="m-btn ghost sm" style={{ width: "100%", justifyContent: "flex-start" }}><Icon name="headset" size={11}/> Escuchar (00:20)</button>
            <button className="m-btn ghost sm" style={{ width: "100%", justifyContent: "flex-start", marginTop: 6 }}><Icon name="movie" size={11}/> Ver el flash</button>
          </div>

          {/* Article */}
          <div style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <div className="m-panel" style={{ padding: "32px 40px", overflowY: "auto" }}>
              <MEye>EDU · FLASH · iniciación</MEye>
              <h1 className="m-serif" style={{ fontSize: 30, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.02em", margin: "8px 0 12px", fontStyle: "normal" }}>
                Una tendencia no es una línea recta.
              </h1>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>autor · finaz_atelier</span>
                <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>· lectura 90 s</span>
              </div>
              <p style={{ fontSize: 15, color: "var(--m-text)", lineHeight: 1.55, marginTop: 18, textWrap: "pretty" }}>
                Mirar una sola vela y declarar una tendencia es como mirar un fotograma y opinar sobre la película. La tendencia vive en la <em style={{ color: "var(--m-accent)" }}>secuencia</em>: máximos y mínimos que se ordenan de una manera reconocible.
              </p>

              <div style={{ marginTop: 18 }}>
                <MChart width={580} height={220} caption="XYZ · 1D · 28 sesiones" ohlcLabel={false}
                  overlays={[
                    { type: "swing", xPct: 18, yPct: 78, label: "HL" },
                    { type: "swing", xPct: 40, yPct: 62, label: "HL" },
                    { type: "swing", xPct: 64, yPct: 42, label: "HH" },
                    { type: "swing", xPct: 84, yPct: 30, label: "HH" },
                    { type: "trend", from: [12, 86], to: [88, 36], color: "rgba(216,168,104,0.6)" },
                  ]}/>
                <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 6, textAlign: "center" }}>
                  Fig. 1 · Tres HL consecutivos sostienen la estructura
                </div>
              </div>

              <h3 style={{ fontSize: 16, fontWeight: 600, marginTop: 22, letterSpacing: "-0.01em" }}>Cautela</h3>
              <div className="m-misconception" style={{ marginTop: 8, padding: 12 }}>
                <div className="lbl">vela_aislada_define_tendencia</div>
                <div style={{ fontSize: 13, marginTop: 6, color: "var(--m-text-2)" }}>
                  Una vela roja no rompe una secuencia. Espera al cierre y observa qué hace el mínimo siguiente.
                </div>
              </div>
            </div>
          </div>

          {/* Side rail */}
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <FlashContextRight/>
          </div>
        </div>
        <MSourceRail source="vendor_primary · XYZ 1D" time="14:32 UTC"
          note="FLASH · reading mode · paridad con player"/>
      </div>
    </div>
  </div>
);

// ──────────────────────────────────────────────────────────
// 09 · Flash · AudioOnly
// ──────────────────────────────────────────────────────────
export const ScreenMFlashAudio = () => (
  <div className="m-screen-d materia" data-screen-label="Flash · AudioOnly">
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="explore"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <MTopBar crumbs={["EducaFinaz", "Educa", "Flash", "TREND_STRUCTURE_20S", "Audio-only"]}/>
        <div style={{ flex: 1, display: "grid", gridTemplateColumns: "1fr 360px", gap: 24, padding: "30px 40px", overflow: "hidden" }}>
          <div className="m-panel" style={{ padding: 36, display: "flex", flexDirection: "column" }}>
            <MEye>Audio-only · 00:20</MEye>
            <div style={{ marginTop: 32, display: "flex", alignItems: "center", gap: 28 }}>
              {/* Voice avatar */}
              <div style={{
                width: 160, height: 160, borderRadius: 99, position: "relative",
                background: "radial-gradient(circle at 30% 30%, #d8a868, #c97a4b 50%, #6e3c1d)",
                boxShadow: "inset 0 4px 30px rgba(0,0,0,0.4), 0 20px 60px rgba(201,122,75,0.25)",
                display: "grid", placeItems: "center",
              }}>
                <Icon name="audio-wave" size={36} style={{ color: "#1c0e07" }}/>
                {/* pulse rings */}
                {[1,2,3].map(i => (
                  <span key={i} style={{
                    position: "absolute", inset: -i * 14, borderRadius: 99,
                    border: "1px solid rgba(216,168,104,0.25)",
                  }}/>
                ))}
              </div>
              <div>
                <div className="mono" style={{ fontSize: 11, color: "var(--m-text-3)", letterSpacing: "0.14em" }}>VOZ · PROFESOR_ANALISTA</div>
                <div className="m-serif" style={{ fontSize: 26, lineHeight: 1.2, marginTop: 8, fontStyle: "normal", letterSpacing: "-0.02em", textWrap: "balance" }}>
                  Una tendencia alcista deja máximos y mínimos cada vez <span style={{ color: "var(--m-accent)" }}>más altos</span>.
                </div>
              </div>
            </div>

            {/* Player */}
            <div style={{ marginTop: 36 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <button className="m-iconbtn primary" style={{ width: 52, height: 52, borderRadius: 99 }}><Icon name="pause" size={20}/></button>
                <div style={{ flex: 1 }}>
                  <div style={{
                    height: 32, position: "relative",
                    background: `repeating-linear-gradient(90deg,
                      rgba(216,168,104,0.45) 0px, rgba(216,168,104,0.45) 2px,
                      rgba(216,168,104,0.18) 2px, rgba(216,168,104,0.18) 5px,
                      rgba(216,168,104,0.05) 5px, rgba(216,168,104,0.05) 9px)`,
                    borderRadius: 2,
                  }}>
                    <div style={{ position: "absolute", left: "70%", top: 0, bottom: 0, width: 2, background: "var(--m-accent)" }}/>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                    <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>00:14</span>
                    <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>00:20</span>
                  </div>
                </div>
                <button className="m-iconbtn"><Icon name="cc" size={16}/></button>
                <button className="m-iconbtn"><Icon name="audio-wave" size={16}/></button>
              </div>
            </div>

            <div className="m-divider" style={{ margin: "30px 0" }}/>

            {/* Verbal quiz */}
            <MEye>Pregunta verbal</MEye>
            <div style={{ fontSize: 17, marginTop: 8 }}>¿La has retenido?</div>
            <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8, maxWidth: 480 }}>
              {[
                { l: "Sí, sin esfuerzo",  k: "1" },
                { l: "Sí, con esfuerzo", k: "2", on: true },
                { l: "Repetir",  k: "3" },
              ].map((o, i) => (
                <div key={i} className={`m-option ${o.on ? "selected" : ""}`}>
                  <div className="radio"/>
                  <span style={{ flex: 1, fontSize: 13 }}>{o.l}</span>
                  <span className="m-kbd">{o.k}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Transcript */}
          <div className="m-panel" style={{ padding: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <MEye>Transcript</MEye>
              <button className="m-btn ghost sm"><Icon name="movie" size={11}/></button>
            </div>
            <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { t: "00:00", l: "Una tendencia no es una línea recta.", on: false },
                { t: "00:05", l: "Mira la estructura, no una sola vela.", on: false },
                { t: "00:11", l: "Una tendencia alcista deja máximos…", on: true },
                { t: "00:17", l: "Y mínimos cada vez más altos." },
              ].map((s, i) => (
                <div key={i} style={{
                  display: "flex", gap: 10, alignItems: "flex-start",
                  padding: "8px 10px", borderRadius: 4,
                  background: s.on ? "rgba(216,168,104,0.10)" : "transparent",
                  borderLeft: s.on ? "2px solid var(--m-accent)" : "2px solid transparent",
                }}>
                  <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", marginTop: 2 }}>{s.t}</span>
                  <span style={{ flex: 1, fontSize: 12, color: s.on ? "var(--m-text)" : "var(--m-text-2)", lineHeight: 1.4 }}>{s.l}</span>
                </div>
              ))}
            </div>
            <div className="m-divider" style={{ margin: "14px 0" }}/>
            <MEye>Saltar al acto</MEye>
            <div style={{ display: "flex", gap: 4, marginTop: 8 }}>
              {["A1","A2","A3","A4","A5"].map(a => (
                <button key={a} className="m-kbd" style={{ fontSize: 10.5, padding: "4px 8px" }}>{a}</button>
              ))}
            </div>
          </div>
        </div>
        <MSourceRail/>
      </div>
    </div>
  </div>
);

// ──────────────────────────────────────────────────────────
// 10 · Flash · Spaced (recap card)
// ──────────────────────────────────────────────────────────
export const ScreenMFlashSpaced = () => (
  <div className="m-screen-d materia" data-screen-label="Flash · Recap · Spaced">
    <div style={{ display: "flex", height: "100%", position: "relative", zIndex: 1 }}>
      <MRail active="review"/>
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <MTopBar crumbs={["EducaFinaz", "Repaso", "Hoy · 3 cards", "card 2 de 3"]}/>

        <div style={{ flex: 1, display: "grid", gridTemplateColumns: "300px minmax(0, 1fr) 300px", gap: 24, padding: "40px 40px" }}>
          {/* Queue */}
          <div>
            <MEye>Cola de hoy</MEye>
            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
              {[
                { t: "Vela roja en tendencia alcista", d: "día 3 · iniciación", done: true },
                { t: "Confirmación de ruptura", d: "día 4 · medio", now: true },
                { t: "RSI alto no implica vender", d: "día 10 · medio", future: true },
              ].map((c, i) => (
                <div key={i} style={{
                  padding: "10px 12px", borderRadius: 4,
                  border: `1px solid ${c.now ? "var(--m-primary)" : "var(--m-line)"}`,
                  background: c.now ? "rgba(201,122,75,0.10)" : "transparent",
                  opacity: c.done ? 0.55 : 1,
                }}>
                  <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: c.done ? "var(--m-positive)" : c.now ? "var(--m-primary)" : "var(--m-text-3)" }}>{c.d}</div>
                  <div style={{ fontSize: 12, marginTop: 4, textDecoration: c.done ? "line-through" : "none" }}>{c.t}</div>
                </div>
              ))}
            </div>
            <div className="m-divider" style={{ margin: "16px 0" }}/>
            <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>STREAK · 12 días · próxima cita mañana</div>
          </div>

          {/* Flashcard */}
          <div style={{ display: "grid", placeItems: "center" }}>
            <div className="m-panel" style={{
              width: 460, padding: 32,
              background: "linear-gradient(180deg, #2f2820, #1c1814)",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <MChip>FLASHCARD · día 4</MChip>
                <span className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>card 2 / 3</span>
              </div>
              <div className="m-serif" style={{
                fontSize: 26, lineHeight: 1.2, marginTop: 28, marginBottom: 28,
                letterSpacing: "-0.015em", textWrap: "balance", fontStyle: "normal",
              }}>
                ¿Una vela roja rompe una tendencia alcista por sí sola?
              </div>
              <button className="m-btn ghost lg" style={{ width: "100%" }}>
                <Icon name="down" size={14}/> Mostrar respuesta
              </button>
              <div className="m-divider" style={{ margin: "26px 0 16px" }}/>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="m-btn ghost sm" style={{ flex: 1, borderColor: "rgba(155,184,106,0.4)", color: "var(--m-positive)" }}>Sin esfuerzo</button>
                <button className="m-btn ghost sm" style={{ flex: 1, borderColor: "rgba(216,168,104,0.4)", color: "var(--m-warn)" }}>Con esfuerzo</button>
                <button className="m-btn ghost sm" style={{ flex: 1, borderColor: "rgba(201,92,78,0.4)", color: "var(--m-negative)" }}>Fallé</button>
              </div>
              <div className="m-divider" style={{ margin: "16px 0" }}/>
              <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)", textAlign: "center", letterSpacing: "0.06em" }}>
                self-rate alimenta spaced_recall_schedule
              </div>
            </div>
          </div>

          {/* Side */}
          <div>
            <MEye>Procedencia</MEye>
            <div className="m-panel" style={{ padding: 16, marginTop: 10 }}>
              <div style={{ fontSize: 12, color: "var(--m-text-2)", lineHeight: 1.4 }}>
                Esta tarjeta se generó al completar el flash <span style={{ color: "var(--m-accent)" }}>TREND_STRUCTURE_20S</span> el día 1.
              </div>
              <div className="m-divider" style={{ margin: "12px 0" }}/>
              <div className="mono" style={{ fontSize: 10, color: "var(--m-text-3)" }}>
                programada · día 4 / 10 / 21 / 45
              </div>
            </div>
            <div className="m-panel" style={{ padding: 16, marginTop: 14 }}>
              <MEye>Si fallas hoy</MEye>
              <div style={{ fontSize: 12, color: "var(--m-text-2)", marginTop: 8, lineHeight: 1.4 }}>
                El sistema te ofrecerá el Flash original como remediación.
              </div>
            </div>
          </div>
        </div>
        <MSourceRail source="EducaFinaz · spaced_recall" time="07:30 local" note="Sin penalización · sin streak break"/>
      </div>
    </div>
  </div>
);
